import { Component, QueryList, ViewChildren } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { FiltrosService } from '../../../services/riesgo-credito/filtros/filtros.service';
import { PerdidaService} from './../../../services/riesgo-credito/riesgos/perdida.service';
import { perdidaEntity,GraficaPedidaEntity, exposicionEntity, categoriaCreditoEntity } from './../entities_riesgos/entities_riesgos';
import { formatear, FuncionesRiesgo} from '../../funciones/funcionesGenerales';
import { Aligment, ExcelService, FormatText } from '../../../services/excel/excel.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { companiesRiesgoCredito } from '../../../shared/catalogos';
import { FiltersM, typesApex } from '../../../components/models';
import { MenuComponent } from '../../menu/menu.component';
import { firstValueFrom } from 'rxjs';
import { messages } from '../../funciones/mensajes';
import { PeriodosService } from '../../../services/riesgo-credito/riesgos/periodos.service';
import moment from 'moment';
import { TextUtils } from '../../../components/pipes/text-utils';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';
import { MatrizExposicionService } from '../../../services/riesgo-credito/riesgos/matriz-exposicion.service';
import { CategoriasCreditoService } from '../../../services/riesgo-credito/riesgos/categorias.service';
@Component({
  selector: 'app-tendencia-perdida',
  templateUrl: './tendencia-perdida.component.html',
  styleUrl: './tendencia-perdida.component.css'
})
export class TendenciaPerdidaComponent {
  @ViewChildren(GraficadorComponent)grafCmp!:QueryList<GraficadorComponent>;
  public Filters = FiltersM;
  /* Declaración de variables */
  public idInstitucion = 1002;
  public DatosAnios;
  public aniosDisponibles: any [];
  public mesesDisponibles: any [];
  public mesesDeAnioDisponibles: any[];
  public puedeFiltrarPorMeses = false;
  public mesSeleccionado: any;
  public subtituloGraficaTabla:string = "";
  public encPers = ""
  public subtituloGrafica:string = "";
  // public colorScheme = ['#224E97', '#1292E9', '#1BC1F5', '#A0DEF3', '#7DC3DD', '#82CC60' ];
  colorScheme : any = ['#6BAED6', '#A6D9C9', '#C5B0D5', '#F7B267', '#FEE191', '#BFD8B8', '#A8CBE8', '#F6A6A1', '#8FD8D2', '#7BAEBE' ];


  public ult_anio: any [] = [];
  public ult_mes: any [] = [];

  grafTablaModal: number = 0; // 1 -> grafica 2 -> tablaPerdida 3 -> TablaExposicion
  //declaración de variables gráfica 
  data = [ ];
  showLabels: boolean = false;
  xAxisLabel: string = 'Período';
  yAxisLabel: string[] = ['Monto'];
  multi = [];
  etiquetas = [];
  tipoGraf = typesApex
  tipoSelec = this.tipoGraf.AREA;
  changeLabel = true;

  mostrarTabla = false;

  menuPerspec = MenuComponent;
  // variables matriz de transicion
  private numPeriodosExp: number;
  public periodosExp;
  public dataExp:any[] = [];
  private exposicion = new exposicionEntity;
  private categorias = new categoriaCreditoEntity;
  public columnas;
  public formatear(num){
    return `${FuncionesRiesgo.formatearnormal(num.toFixed(0))}`;
  }

  /**
   * variables de tabla
   */
  public tableDataSource :any []= [];
  dataSource: any[] = [];

  perdida = new perdidaEntity;
  dataPerdidaEsperada: any [] = [];

  suma_PerdidaEsperada: number;
  suma_PerdidaNoEsperada95: number;
  suma_VaR95: number;
  
  todas_perdidas: boolean = true;
  public filtroPerdidas = [];
  perspectiva: boolean = false;
  titulomodal: string = "";
  subtitulomodal: string = "";

  flag_suc: boolean = false;
  suc_name: string = "";
  flag_zona: boolean = false;
  zona_name: string = "";
  flag_producto: boolean = false;
  producto_name: string = "";
  aniomesSeleccionado: string = "";
  public miles : string = ',';
  public decimal : string = '.';
  public modalOpen: boolean = false;
  public labelsModal: boolean;
  public iconoExportar: string;
  // VARIABLES PERSONALIZACION CATALAGO
  private bndInteres: boolean; // false -> sin intereses   true -> con intereses
  public submenus: number; 

  /* Declaración de variables */
  constructor(
    public dataService: DataService,
    private filtrosService: FiltrosService,
    private perdidaService: PerdidaService,
    private exposicionService: MatrizExposicionService,
    private categoriasService: CategoriasCreditoService,
    private excelService: ExcelService,
    private translate: TranslateService,
    private periodosService: PeriodosService,
    private cookies: CookieService
  ){
    formatear.momentAbrev();
    this.idInstitucion = Number(cookies.get('idInstitucion'));
    this.personalizacion();
    this.getPeriodos();
  }
  public filterChange(filtro){
    switch (filtro.filtro){
      case 'zona': 
        this.filtrarZona(filtro.elem);
        break;
      case 'sucursal':
        this.filtrarSucursal(filtro.elem);
        break;
      case 'producto': 
        this.filtrarProducto(filtro.elem);
        break;
    }
  }
  private personalizacion(){
    var configInst = companiesRiesgoCredito.find(c => Number(c.id) === this.idInstitucion);
    this.translate
      .get([
        'filtros.perEsp',
        'filtros.perNoEsp',
        'riesgo-credito.tendencia.var',
      ])
      .subscribe((t) => {
        this.filtroPerdidas = [
          { id: 1, name: t['filtros.perEsp'], check: true },
          { id: 2, name: t['filtros.perNoEsp'], check: true },
          { id: 3, name: t['riesgo-credito.tendencia.var'], check: true },
        ];
      });
    this.bndInteres = configInst.interes;
    this.submenus = configInst.tipoMenu;
  }
  private async getPeriodos(){
    const info = await firstValueFrom(
      this.periodosService.getByAddUrl_Riesgo('informacionCargada', {InstitucionId: this.idInstitucion})
    );
    if(info.length > 0){
      this.DatosAnios = formatear.periodosRC(info);
      this.FuncionesDataSource();
    }else{
      var nombre = companiesRiesgoCredito.find(c => Number(c.id) === this.idInstitucion).name;
      messages.infoMessageGraph(nombre + this.translate.instant('swal.instNoInfo'));
    }    
  }
  filtrarZona(zona){
    this.flag_suc = false;
    this.flag_zona = true;
    this.flag_producto = false;
    this.perdida.SucursalId = null;
    this.perdida.ZonaId = zona.ZonaId;
    this.zona_name = zona.Nombre_Zona;
    this.perdida.ProductoId = null;
    this.exposicion.ZonaId = zona.ZonaId;
    this.exposicion.ProductoId = null;
    this.exposicion.SucursalId = null;
    this.funcionPerdida(this.perdida);
    this.getMatrizExp();
  }
  filtrarProducto(producto){
    this.flag_suc = false;
    this.flag_producto = true;
    this.flag_zona = false;
    this.perdida.SucursalId = null;
    this.perdida.ZonaId = null;
    this.perdida.ProductoId = producto.ProductoId;
    this.producto_name = producto.Nombre_Producto;
    this.exposicion.ZonaId = null;
    this.exposicion.ProductoId = producto.ProductoId;
    this.exposicion.SucursalId = null;
    this.funcionPerdida(this.perdida);
    this.getMatrizExp();
  }
  filtrarSucursal(suc){
    this.flag_suc = true;
    this.flag_zona = false;
    this.flag_producto = false;
    this.perdida.ZonaId = null;
    this.perdida.ProductoId = null;
    this.perdida.SucursalId = suc.SucursalId;
    this.suc_name = suc.Nombre_Sucursal;
    this.exposicion.ZonaId = null;
    this.exposicion.ProductoId = null;
    this.exposicion.SucursalId = suc.SucursalId;
    this.funcionPerdida(this.perdida);
    this.getMatrizExp();
  }
  public anioChangeListener(anioClick: object): void {
    this.ult_anio = [];
    this.aniosDisponibles = this.filtrosService.changeElementCheckStatusFiltroUnAnio_return(anioClick, this.aniosDisponibles);
    const anio_selecc = this.aniosDisponibles.find(anio => anio.name === anioClick['name']);
    this.mesesDeAnioDisponibles = this.mesesDisponibles.filter(mes => mes.year === anio_selecc.name);
    for (const valor of this.mesesDeAnioDisponibles){
      valor['check'] = false;
    }
    this.mesesDeAnioDisponibles[this.mesesDeAnioDisponibles.length - 1].check = true;
    this.mesSeleccionado = this.mesesDeAnioDisponibles[this.mesesDeAnioDisponibles.length - 1];
    this.perdida.Periodo=this.mesesDeAnioDisponibles[this.mesesDeAnioDisponibles.length - 1].value;
    this.funcionPerdida(this.perdida);
    this.getPeriodosExp(this.mesSeleccionado);
    this.aniomesSeleccionado = this.mesSeleccionado["name"]+" "+this.mesSeleccionado["year"].substring(2,4)
  }
  // MESES
  public mesChangeListener(mesClick: object, elementArray: object[]): void {
    this.filtrosService.changeElementCheckStatusFiltroUnAnio(mesClick, elementArray);
    this.ult_mes = [];
    for (const valor of this.mesesDeAnioDisponibles){
      if (valor['check']== true){
        this.ult_mes.push(valor['value'])
      }
    }
    this.mesSeleccionado = this.mesesDeAnioDisponibles.find(e => e.check);
    this.perdida.Periodo = Number(this.ult_mes[0]);
    this.funcionPerdida(this.perdida);
    this.getPeriodosExp(this.mesSeleccionado);
    this.aniomesSeleccionado = this.mesSeleccionado["name"]+" "+this.mesSeleccionado["year"].substring(2,4)
  }
  // SUCURSALES
  public consolidadoChangeListener(tipo): void {
    if(tipo === "consolidado"){
      this.todas_perdidas = !this.todas_perdidas;
      if(this.todas_perdidas){
        for(const p of this.filtroPerdidas){
          p.check = true;
        }
      }
    }else{
      for(const p of this.filtroPerdidas){
        if(p.name === tipo.name){
          p.check = !p.check;
        }
      }
    }
    this.construirArregloGraficaAreaLineal(this.dataPerdidaEsperada);
  }
  public quitarFiltros(): void {
    var pos = 0;
    for(var i =0; i < this.aniosDisponibles.length; i++){
      this.aniosDisponibles[i].check = false;
    }
    this.aniosDisponibles[this.aniosDisponibles.length-1].check = true;
    for(var i = 0; i < this.mesesDisponibles.length; i++ ){
      this.mesesDisponibles[i].check = false;
    }
    var aux = [];
    for(var i =0; i < this.DatosAnios.mesesDisponibles.length; i++){
      if(this.DatosAnios.mesesDisponibles[i].year == this.aniosDisponibles[this.aniosDisponibles.length-1].name){
        aux.push(this.DatosAnios.mesesDisponibles[i]);
      }
    }
    this.mesesDisponibles=aux;
    this.mesesDisponibles[this.mesesDisponibles.length-1].check = true;
    this.flag_producto = false;
    this.flag_zona = false;
    this.flag_suc = false;
    this.perspectiva = false;
    this.todas_perdidas = true;
    for(const p of this.filtroPerdidas){
      p.check = true;
    }
    this.perdida.ZonaId = null;
    this.perdida.ProductoId = null;
    this.perdida.SucursalId = null;
    this.tipoSelec = this.tipoGraf.AREA;
    this.showLabels = false;
    this.changeLabel = true
    this.FuncionesDataSource();
  }
  /* funciones eventos de las gráficas */
  onSelect(event){
    this.perspectiva = true;
    let RespaldoDataSource = this.tableDataSource;
    this.dataSource = [];
    let variable = RespaldoDataSource.find(name => name.periodo == event.name);
    this.dataSource.push(variable);
    this.sumasTotales();
    this.aniomesSeleccionado = event.name.split(' ')[0] +" "+ this.mesSeleccionado["year"].substring(2,4);    
  }
  sumasTotales(){
    this.suma_PerdidaEsperada = 0;
    this.suma_PerdidaNoEsperada95 = 0;
    this.suma_VaR95 = 0;
    for (const d of this.dataSource){
      this.suma_PerdidaEsperada += d['perdidaesperada'];
      this.suma_PerdidaNoEsperada95 += d['perdidanoesperada'];
      this.suma_VaR95 += d['var90'];
    }
  }
  /* Funciones para construir los datos de graficas, tablas y variables */
  public FuncionesDataSource(){
    this.aniosDisponibles = this.DatosAnios.aniosDisponibles;
    this.mesesDisponibles = this.DatosAnios.mesesDisponibles;
    let ult_anio = this.aniosDisponibles[this.aniosDisponibles.length-1].name;
    this.aniosDisponibles[this.aniosDisponibles.length-1].check = true;
    this.mesesDeAnioDisponibles = this.mesesDisponibles.filter(mes => mes.year === ult_anio);
    let ult_mes = this.mesesDeAnioDisponibles[this.mesesDeAnioDisponibles.length - 1].name;
    this.mesesDeAnioDisponibles[this.mesesDeAnioDisponibles.length - 1].check = true;
    this.mesSeleccionado = this.mesesDeAnioDisponibles.find(mes => mes.name === ult_mes);
    this.perdida.InstitucionId = this.idInstitucion;
    this.perdida.Periodo = Number(this.mesSeleccionado.value);
    switch(this.idInstitucion){
      case 1004:
        this.perdida.NPeriodosHst= 9;
        this.perdida.NPeriodos= 9;
        this.numPeriodosExp = 9;
        break;
      case 2008:
        this.perdida.NPeriodosHst = 11;
        this.perdida.NPeriodos = 11;
        this.numPeriodosExp = 11;
        break;
      default:
        this.perdida.NPeriodosHst= 12;
        this.perdida.NPeriodos= 12;
        this.numPeriodosExp = 12;
        break;
    }
    this.getPeriodosExp(this.mesSeleccionado);
    this.perdida.ZonaId = -1;
    this.perdida.SucursalId = -1;
    this.perdida.ProductoId = -1;
    this.perdida.BnIntereses = this.bndInteres;
    this.funcionPerdida(this.perdida);
    this.aniomesSeleccionado = this.mesSeleccionado["name"]+" "+this.mesSeleccionado["year"].substring(2,4)
  }
  FuncionsubTituloGrafica(){
    let cadena_anio_meses = this.aniomesSeleccionado;
    this.subtituloGrafica = cadena_anio_meses;
    if(this.filtroPerdidas[0].check)
      this.subtituloGrafica += " | Pérdida esperada"
    if(this.filtroPerdidas[1].check)
      this.subtituloGrafica += " | Pérdida no esperada"
    if(this.filtroPerdidas[2].check)
      this.subtituloGrafica += " | Variación "
    if (this.flag_zona)
      this.subtituloGrafica += " | Región " + TextUtils.capitalize(this.zona_name, 'words');
    if (this.flag_producto)
      this.subtituloGrafica += " | Producto " + this.producto_name;
    if (this.flag_suc)
      this.subtituloGrafica += " | Oficina " + TextUtils.capitalize(this.suc_name, 'words');
  }
  FuncionsubTituloGraficaDos(){
    if (this.flag_suc){
      this.subtituloGraficaTabla += " | Oficina " + TextUtils.capitalize(this.suc_name, 'words');
    }
    if (this.flag_zona){
      this.subtituloGraficaTabla += " | Región " + TextUtils.capitalize(this.zona_name, 'words');
    }
    if (this.flag_producto){
      this.subtituloGraficaTabla += " | Producto " + this.producto_name;
    }  
  }
  async funcionPerdida(perdidaEntity){
    try{
      const res = await firstValueFrom(this.perdidaService.getByAddUrl_Riesgo('perdida',perdidaEntity)); 
      this.dataPerdidaEsperada = res;
      this.construirArregloGraficaAreaLineal(res);
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  construirArregloGraficaAreaLineal(dataArr){
    this.multi = [];
    let arrPerdidaEsperada: any[] = [];
    let arrPerdidaNoEsperada: any[] = [];
    let arrVar: any[] = [];
    let arraux: any[] = [];
    let dataSourceTable:any[] = [];
    this.data = [];
    this.suma_PerdidaEsperada = 0;
    this.suma_PerdidaNoEsperada95 = 0;
    this.suma_VaR95 = 0;
    for(const data of dataArr){
      let fec = moment(data.Periodo, 'YYYYMM').format('MMM YY');
      this.etiquetas.push(fec);
      arraux.push(fec);
      if(this.todas_perdidas){
        dataSourceTable.push({"periodo":fec,"perdidaesperada":data['PerdidaEsperada'],"perdidanoesperada":data["PerdidaNoEsperada95"],"var90":data["VaR95"]});
        arrPerdidaEsperada.push(data['PerdidaEsperada']);
        arrPerdidaNoEsperada.push(data['PerdidaNoEsperada95']);
        arrVar.push(data['VaR95']);
        arraux.push(data['VaR95']);
        arraux.push(data['PerdidaNoEsperada95']);
        arraux.push(data['PerdidaEsperada']);
        
        if(data['Periodo'] == this.mesSeleccionado.value){
          this.suma_PerdidaEsperada += data['PerdidaEsperada'];
          this.suma_PerdidaNoEsperada95 += data['PerdidaNoEsperada95'];
          this.suma_VaR95 += data['VaR95'];
        }
      }else{
        let grafica = new GraficaPedidaEntity;
        grafica.periodo = fec;
        if(this.filtroPerdidas[0].check){
          arrPerdidaEsperada.push(data['PerdidaEsperada']);
          arraux.push(data['PerdidaEsperada']);
        }
        if(this.filtroPerdidas[1].check){
          arrPerdidaNoEsperada.push(data['PerdidaNoEsperada95']);
          arraux.push(data['PerdidaNoEsperada95']);
        }
        if(this.filtroPerdidas[2].check){
          arrVar.push(data['VaR95']);
          arraux.push(data['VaR95']);
        }
        if(data['Periodo'] == this.mesSeleccionado.value){
          this.suma_PerdidaEsperada += data['PerdidaEsperada'];
          this.suma_PerdidaNoEsperada95 += data['PerdidaNoEsperada95'];
          this.suma_VaR95 += data['VaR95'];
        }
        grafica.perdidaesperada = data['PerdidaEsperada'];
        grafica.perdidanoesperada = data['PerdidaNoEsperada95'];
        grafica.var90 = data['VaR95'];
        dataSourceTable.push(grafica);
      }      
      this.data.push(arraux);
      arraux = [];
    }
    if(this.filtroPerdidas[2].check){
      this.multi.push({name:'Var',data:arrVar.reverse()});
    }
    if(this.filtroPerdidas[1].check){
      this.multi.push({name:'Pérdida no esperada',data:arrPerdidaNoEsperada.reverse()});
    }
    if(this.filtroPerdidas[0].check){
      this.multi.push({name:'Pérdida esperada',data:arrPerdidaEsperada.reverse()});
    }
    this.etiquetas = this.etiquetas.reverse();
    this.multi[0].data = this.multi[0].data;
    this.dataSource = dataSourceTable;
    this.tableDataSource = this.dataSource;
    this.subtituloGrafica = "";
    this.FuncionsubTituloGrafica();
  }
  /* Ampliar gráficas */
  public AmpliarGraficaC1(item){
    this.grafTablaModal = item;
    var tit = item !== 3 ? `menu.${this.dataService.subModuleSelect}` : 'riesgo-credito.tendencia.titulo';
    this.titulomodal = this.translate.instant(tit);
    this.subtitulomodal = item !== 3 ? this.subtituloGrafica : this.subtituloGraficaTabla;
    this.labelsModal = item !== 3;
    this.iconoExportar = item !== 3 ? 'image' : 'description';
    this.modalOpen = true;
    // document.getElementById('ampliarGraficas').style.display='block';
  }
  /* Exportar CSV*/
  export_csv(tabla: number){
    var titulos = [], alineacion = [], formato = [], aux = [], data_excel = [];
    var nombreArch = '', titHoja = '';
    if(tabla === 2){
      titulos= [
        this.translate.instant('riesgo-credito.tendencia.tit1'),
        this.translate.instant('riesgo-credito.tendencia.tit2'),
        this.translate.instant('riesgo-credito.tendencia.tit3'),
        this.translate.instant('riesgo-credito.tendencia.var'),
      ]
      alineacion = [Aligment.CENTER,Aligment.CENTER,Aligment.CENTER,Aligment.CENTER];
      formato = [FormatText.TEXT, FormatText.NUMBER, FormatText.NUMBER, FormatText.NUMBER]
      for (const ele of this.dataSource){
        aux = [];
        aux.push(ele["periodo"])
        aux.push(ele["perdidaesperada"]);
        aux.push(ele["perdidanoesperada"]);
        aux.push(ele["var90"]);
        data_excel.push(aux)
      }
      nombreArch = "TendenciaPerdida " +this.mesSeleccionado["name"]+"-"+this.mesSeleccionado["year"];
      titHoja = this.translate.instant('menu.'+this.dataService.moduleSelect) + " • " + this.translate.instant('menu.'+this.dataService.subModuleSelect) + " " + this.subtituloGrafica;
    }
    if(tabla === 3){
      titulos = [this.translate.instant('riesgo-credito.tendencia.tit4'),
      this.translate.instant('riesgo-credito.tendencia.tit5'),
      this.translate.instant('riesgo-credito.tendencia.tit6'),
      this.translate.instant('riesgo-credito.tendencia.tit2')]
      alineacion.push(Aligment.CENTER,Aligment.CENTER,Aligment.CENTER,Aligment.CENTER);
      formato.push(FormatText.TEXT,FormatText.NUMBER,FormatText.PORCENTAJE,FormatText.NUMBER);
      for(const d of this.dataExp){
        aux = [];
        aux.push(d.nombre);
        aux.push(d.saldo);
        aux.push(d.prob);
        aux.push(d.perdida);
        data_excel.push(aux);
      }
      nombreArch = 'Exposicion ' + this.subtituloGraficaTabla;
      titHoja = `${this.translate.instant('riesgo-credito.tendencia.titulo')} ${this.subtituloGraficaTabla}`
    }
    this.excelService.generateExcel(titHoja,titulos,data_excel,nombreArch,alineacion, formato);    
  }
  /* Exportar img */
  export_img(zon: any){
    var name = { 
      titulo: this.translate.instant('menu.'+this.dataService.subModuleSelect),
      subtitulo: this.subtituloGrafica,
      nombreArch: this.translate.instant('menu.'+this.dataService.subModuleSelect)
    }
    
    const comp = this.grafCmp.find(g => g.zona === zon);
    comp.exportImg(zon,name)
  }
  private getPeriodosExp(mesSelec){
    const checkedIndex = this.mesesDisponibles.findIndex(mes => mes.value === mesSelec.value);
    if (checkedIndex !== -1) {
      const start = Math.max(0, checkedIndex - this.numPeriodosExp + 1);
      const p = this.mesesDisponibles.slice(start, checkedIndex + 1).map(mes => ({
        name: `${mes.name} ${mes.year.slice(-2)}`,
        value: mes.value,
        check: false,
      }));
      p.find(p => p.value === mesSelec.value).check = true;
      this.periodosExp = p;
      this.exposicion.InstitucionId = this.idInstitucion;
      this.exposicion.Periodo = Number(mesSelec.value);
      this.exposicion.NPeriodos = this.numPeriodosExp;
      this.exposicion.NPeriodosHst = this.numPeriodosExp;
      this.exposicion.TipoCreditoId = -1;
      this.exposicion.BnIntereses = this.bndInteres;
      this.exposicion.ZonaId = -1;
      this.exposicion.SucursalId = -1;
      this.exposicion.ProductoId = -1;
      this.getMatrizExp();
    } else {
      this.periodosExp = [];
    }
  }

  private async getMatrizExp(){
    try{
      const res = await firstValueFrom(this.exposicionService.getByAddUrl_Riesgo('matrizExp',this.exposicion)); 
      this.categorias.InstitucionId = this.idInstitucion;
      const categorias = await firstValueFrom(this.categoriasService.getByAddUrl_Riesgo('categoriaCredito', this.categorias));
      const data = res.map(item => {
        const categoriaR = categorias.find(cat => cat['CategoriaCreditoId'] === item['CategoriaCreditoId_R']);
        const categoriaC = categorias.find(cat => cat['CategoriaCreditoId'] === item['CategoriaCreditoId_C']);
        return {
          ...item,
          Nombre_CategoriaCredito_R: categoriaR ? categoriaR['Nombre_CategoriaCredito'] : null,
          Nombre_CategoriaCredito_C: categoriaC ? categoriaC['Nombre_CategoriaCredito'] : null,
        };
      });    
      this.ConvertirMatriz(data);
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  public ConvertirMatriz(dataArr){
    let aux = [];
    this.dataExp = [];
    dataArr = dataArr.sort((a,b) => a.Renglon - b.Renglon);
    for(const d of dataArr){
      aux.push({
        nombre: d.Nombre_CategoriaCredito_R,
        saldo: d.Value,
        prob: Number((d.ProbPerdida*100).toFixed(2)),
        perdida: d.Value * d.ProbPerdida
      });
    }
    this.dataExp = [...aux];
    const total = aux.reduce(
      (acc, item) => {
        acc.saldo += item.saldo;
        acc.prob += item.prob;
        acc.perdida += item.perdida;
        return acc;
      },
      { nombre: "Total", saldo: 0, prob: 0, perdida: 0 }
    );

    // this.dataExp.push(total);
    this.subtituloGraficaTabla = this.periodosExp.find(i => i.check).name;    
    this.FuncionsubTituloGraficaDos();
  }
  public cambiarPeriodoExp(per){
    this.periodosExp.forEach(p => p.check = p.value === per.value);
    this.exposicion.Periodo = Number(per.value);
    this.getMatrizExp();
  }
  public exportarModal(){
   if(this.grafTablaModal === 1){
    this.export_img(1)
   }else{
    this.export_csv(this.grafTablaModal);
   }
  }
}
